import React, { useEffect, useRef, useState, useCallback } from 'react';
import '../styles/revamp.css';

// ---- Inline SVGs, preserved verbatim from the approved design ----
const SLIDE_SVGS = [
  // 0 — CSAT turnaround
  `<svg viewBox="0 0 520 260" role="img" aria-label="Client Services CSAT rose from roughly 55% to roughly 90% over twelve months while monthly ticket volume grew about four times" font-family="IBM Plex Sans, sans-serif">
    <line x1="40" y1="75.5" x2="500" y2="75.5" stroke="#3B6570" stroke-dasharray="3 4"/>
    <rect x="52.5" y="165.4" width="20.9" height="34.6" rx="2" fill="#1E4250"/><rect x="90.5" y="165.4" width="20.9" height="34.6" rx="2" fill="#1E4250"/><rect x="128.6" y="165.4" width="20.9" height="34.6" rx="2" fill="#1E4250"/><rect x="166.6" y="165.4" width="20.9" height="34.6" rx="2" fill="#1E4250"/><rect x="204.6" y="148.1" width="20.9" height="51.9" rx="2" fill="#1E4250"/><rect x="242.6" y="130.8" width="20.9" height="69.2" rx="2" fill="#1E4250"/><rect x="280.6" y="79.0" width="20.9" height="121.0" rx="2" fill="#1E4250"/><rect x="318.6" y="61.7" width="20.9" height="138.3" rx="2" fill="#1E4250"/><rect x="356.6" y="61.7" width="20.9" height="138.3" rx="2" fill="#1E4250"/><rect x="394.6" y="61.7" width="20.9" height="138.3" rx="2" fill="#1E4250"/><rect x="432.6" y="44.4" width="20.9" height="155.6" rx="2" fill="#1E4250"/><rect x="470.6" y="44.4" width="20.9" height="155.6" rx="2" fill="#1E4250"/>
    <polyline points="63.0,108.7 101.0,67.2 139.0,58.9 177.0,100.4 215.0,58.9 253.0,75.5 291.0,75.5 329.0,58.9 367.0,83.8 405.0,67.2 443.0,67.2 481.0,50.6" fill="none" stroke="#00D4B4" stroke-width="2.5" stroke-linejoin="round" stroke-linecap="round"/>
    <circle cx="63.0" cy="108.7" r="3" fill="#00D4B4"/><circle cx="101.0" cy="67.2" r="3" fill="#00D4B4"/><circle cx="139.0" cy="58.9" r="3" fill="#00D4B4"/><circle cx="177.0" cy="100.4" r="3" fill="#00D4B4"/><circle cx="215.0" cy="58.9" r="3" fill="#00D4B4"/><circle cx="253.0" cy="75.5" r="3" fill="#00D4B4"/><circle cx="291.0" cy="75.5" r="3" fill="#00D4B4"/><circle cx="329.0" cy="58.9" r="3" fill="#00D4B4"/><circle cx="367.0" cy="83.8" r="3" fill="#00D4B4"/><circle cx="405.0" cy="67.2" r="3" fill="#00D4B4"/><circle cx="443.0" cy="67.2" r="3" fill="#00D4B4"/><circle cx="481.0" cy="50.6" r="3" fill="#00D4B4"/>
    <text x="44" y="70.5" font-size="10" fill="#5F8A8C">75% target</text>
    <text x="63.0" y="124.7" text-anchor="middle" font-size="12" font-weight="600" fill="#C9DBDC">~55%</text>
    <text x="473.0" y="53.6" text-anchor="end" font-size="13" font-weight="600" fill="#00D4B4">~90%</text>
    <text x="63.0" y="160.4" text-anchor="middle" font-size="9" fill="#5F8A8C">~1K</text>
    <text x="481.0" y="66.4" text-anchor="middle" font-size="9" fill="#8FB3B4">~4.5K</text>
    <text x="63.0" y="216" text-anchor="middle" font-size="10" fill="#5F8A8C">Jul</text><text x="101.0" y="216" text-anchor="middle" font-size="10" fill="#5F8A8C">Aug</text><text x="139.0" y="216" text-anchor="middle" font-size="10" fill="#5F8A8C">Sep</text><text x="177.0" y="216" text-anchor="middle" font-size="10" fill="#5F8A8C">Oct</text><text x="215.0" y="216" text-anchor="middle" font-size="10" fill="#5F8A8C">Nov</text><text x="253.0" y="216" text-anchor="middle" font-size="10" fill="#5F8A8C">Dec</text><text x="291.0" y="216" text-anchor="middle" font-size="10" fill="#5F8A8C">Jan</text><text x="329.0" y="216" text-anchor="middle" font-size="10" fill="#5F8A8C">Feb</text><text x="367.0" y="216" text-anchor="middle" font-size="10" fill="#5F8A8C">Mar</text><text x="405.0" y="216" text-anchor="middle" font-size="10" fill="#5F8A8C">Apr</text><text x="443.0" y="216" text-anchor="middle" font-size="10" fill="#5F8A8C">May</text><text x="481.0" y="216" text-anchor="middle" font-size="10" fill="#5F8A8C">Jun</text>
    <text x="40" y="248" font-size="11" fill="#5F8A8C">Monthly ticket volume grew roughly 4x over the same twelve months</text>
  </svg>`,
  // 1 — Teams world map
  `<svg viewBox="0 0 520 260" role="img" aria-label="World map of teams led: in-house teams across all four US time zones, and BPO teams in Mexico City, Bengaluru, and Manila" font-family="IBM Plex Sans, sans-serif">
    <defs><linearGradient id="mapfade" x1="0" y1="0" x2="0" y2="1"><stop offset="0" stop-color="#fff" stop-opacity="0"/><stop offset=".18" stop-color="#fff"/><stop offset=".9" stop-color="#fff"/><stop offset="1" stop-color="#fff" stop-opacity="0"/></linearGradient><mask id="mapmask"><rect width="520" height="200" fill="url(#mapfade)"/></mask></defs><path mask="url(#mapmask)" d="M152 193 156 194 150 195 142 191 147 193 150 191 152 193ZM166 189 166 190 162 190 166 189ZM469 174 473 174 472 177 470 178 468 174 469 174ZM510 174 511 174 509 177 510 178 507 179 506 181 504 182 500 182 501 180 506 177 508 174 510 174ZM512 167 515 169 518 169 517 171 516 171 513 175 512 174 512 172 511 172 512 168 509 164 512 165 512 167ZM501 146 498 145 496 143 501 146ZM327 133 327 136 326 136 323 150 320 151 318 150 317 146 319 143 319 137 323 135 326 131 327 133ZM466 133 469 135 470 141 474 143 475 146 477 146 480 152 480 159 475 169 470 171 468 170 468 169 466 171 462 169 460 167 458 166 458 164 456 165 457 162 455 165 452 161 448 160 440 161 436 163 431 163 428 165 423 164 424 160 421 152 422 152 421 151 422 152 421 149 422 145 422 146 426 144 432 142 435 137 437 138 436 138 439 134 441 133 445 135 447 132 450 131 448 130 449 129 454 131 455 131 456 131 454 135 461 139 463 135 464 129 465 129 466 133ZM437 128 436 128 437 127 442 125 437 128ZM414 123 417 123 424 125 423 126 413 124 409 123 410 122 414 123ZM478 121 476 122 473 121 476 120 477 121 478 119 479 119 478 121ZM446 118 447 119 443 118 443 117 446 118ZM480 120 476 117 479 118 480 120ZM452 115 452 117 454 118 455 116 458 115 467 119 469 121 472 122 471 124 476 129 472 128 468 124 464 127 459 125 457 125 459 124 457 121 451 118 450 119 449 117 451 116 449 116 446 114 449 113 452 115ZM439 111 436 113 431 113 432 115 436 114 433 116 436 121 434 121 435 120 433 120 432 117 431 117 431 121 430 121 430 118 429 117 431 112 432 111 435 112 439 111ZM444 111 443 114 442 110 443 110 444 111ZM410 122 408 122 405 119 394 105 397 105 407 113 406 114 410 117 410 122ZM428 110 429 112 428 112 425 119 416 117 415 114 415 110 418 110 418 109 420 108 426 103 430 105 427 108 428 110ZM440 100 441 102 440 104 440 102 439 103 439 105 437 104 436 101 434 102 436 100 437 101 439 100 439 98 440 100ZM373 104 372 104 371 103 372 98 374 102 373 104ZM437 98 435 100 434 98 435 97 436 97 436 98 437 96 437 98ZM429 99 427 100 430 96 430 97 429 99ZM439 95 439 97 438 96 438 98 437 94 439 95ZM433 85 434 85 435 88 433 89 433 92 437 92 437 94 435 93 432 92 432 91 431 91 431 89 431 89 432 85 433 85ZM145 83 149 84 151 85 148 86 146 87 143 86 142 85 145 85 143 84 145 83ZM417 85 414 85 414 84 417 83 417 85ZM134 79 142 83 137 83 138 83 136 81 131 79 126 80 130 78 134 79ZM433 79 432 80 431 78 433 75 434 76 433 79ZM453 62 452 64 449 64 450 62 453 62ZM276 56 275 59 271 57 271 56 276 56ZM266 52 267 55 266 55 265 52 266 52ZM462 58 461 61 456 61 454 63 453 62 447 63 449 64 448 66 446 66 446 65 445 63 450 60 454 60 456 57 457 58 460 56 461 52 463 51 463 53 462 58ZM466 47 468 47 469 49 465 51 463 50 462 51 461 51 460 50 463 48 463 45 466 47ZM69 41 66 40 62 37 66 38 69 41ZM169 38 168 39 173 40 173 41 174 41 174 42 174 44 172 43 172 42 170 43 169 42 165 42 167 38 170 36 169 38ZM55 33 57 33 56 34 58 35 55 34 55 32 55 33ZM466 38 467 40 465 40 464 42 466 44 465 43 464 45 463 34 465 32 466 38ZM242 35 238 36 239 34 238 33 243 31 244 32 242 35ZM25 28 24 29 23 28 26 27 27 27 25 28ZM248 26 247 27 250 27 248 30 249 30 253 34 255 35 254 36 255 37 245 39 244 38 247 37 245 36 246 35 246 33 248 34 248 33 245 32 245 30 244 31 243 29 245 26 248 26ZM126 15 134 18 129 18 126 19 123 19 124 18 125 15 126 15ZM231 14 231 15 232 16 225 19 219 18 220 17 217 17 220 16 216 15 220 14 222 15 231 14ZM520 10 528 13 528 14 528 13 532 14 535 15 531 16 530 17 522 16 522 15 520 15 521 16 520 16 516 17 519 19 519 20 511 21 506 24 504 23 496 24 493 26 495 27 495 29 493 30 493 31 493 31 491 32 490 34 488 34 486 37 484 31 484 29 486 27 488 27 496 22 497 20 490 23 489 21 485 22 482 24 483 25 477 26 477 25 475 24 464 25 453 32 458 33 460 32 463 34 463 35 461 41 458 44 453 48 451 49 449 49 442 54 445 58 444 61 440 62 440 58 441 58 438 56 439 54 437 54 432 55 434 53 433 52 428 55 427 55 429 57 434 57 435 58 432 58 430 61 434 66 433 67 434 69 433 71 429 76 425 79 417 81 417 83 416 83 416 81 414 81 410 84 410 85 414 90 415 93 415 96 409 100 409 98 406 97 405 95 402 94 403 93 401 93 400 99 406 105 407 111 403 109 401 103 399 100 399 101 399 96 397 88 394 90 393 89 393 86 388 79 387 79 387 80 382 81 381 83 375 88 372 89 371 98 368 101 362 89 360 81 357 82 355 80 356 79 351 75 344 76 338 75 337 73 334 74 329 72 327 68 324 68 328 76 328 74 329 75 330 77 333 77 336 74 337 77 341 80 338 83 338 85 335 87 330 89 330 90 325 92 317 94 316 88 311 81 310 78 304 71 304 69 303 72 301 69 306 77 305 79 307 80 308 85 311 89 317 95 316 95 319 97 329 95 328 97 324 107 312 117 311 120 311 126 313 129 313 135 312 137 304 142 305 149 301 151 301 155 297 159 291 163 286 163 282 165 280 164 280 160 275 153 274 146 270 138 273 131 272 126 270 120 266 115 267 108 265 106 261 107 259 104 257 104 250 106 246 105 241 106 233 101 231 97 228 95 226 91 228 87 228 83 227 82 229 78 233 72 238 68 239 65 242 62 244 60 249 61 255 59 267 57 269 58 268 63 281 68 282 67 282 65 285 64 296 67 299 66 303 67 306 61 306 58 301 59 294 58 291 54 296 52 299 52 302 50 310 52 314 51 314 50 307 46 311 43 305 44 307 46 303 47 301 46 302 44 298 44 295 46 294 50 295 52 292 53 290 52 288 52 289 53 288 54 286 53 288 57 287 57 287 59 286 59 281 53 282 51 272 45 271 45 271 47 280 53 278 53 277 54 278 55 276 56 275 53 266 47 262 49 257 49 257 51 254 52 252 55 253 55 249 58 246 58 245 60 243 58 239 58 239 56 238 55 240 52 239 49 241 48 250 48 251 48 251 45 246 42 246 41 250 41 250 39 251 40 255 38 255 37 258 36 260 34 265 33 266 33 265 30 265 28 268 27 268 28 269 29 267 31 269 33 271 32 274 33 279 31 282 32 284 31 285 28 286 27 288 28 289 26 287 25 296 24 294 23 287 24 284 23 285 19 290 16 288 15 286 15 284 17 279 20 278 22 280 24 278 26 276 30 272 31 268 25 265 26 261 26 260 21 268 17 275 12 281 9 294 7 299 8 297 9 299 10 300 9 312 12 314 14 312 14 302 14 304 15 304 17 308 18 307 17 308 16 311 17 313 17 312 16 315 14 318 15 319 14 317 11 321 12 322 12 320 13 320 13 321 14 332 11 333 11 332 12 340 11 342 11 343 10 342 10 343 9 354 12 355 11 352 10 352 7 356 4 360 5 361 6 359 7 361 8 360 10 362 11 358 14 360 15 364 12 363 11 364 10 362 9 363 8 361 7 364 6 363 5 365 5 364 7 366 7 365 6 368 6 374 6 372 3 382 3 380 2 382 1 402 -1 408 -3 412 -1 418 -1 422 0 415 3 420 3 421 4 424 3 436 4 436 3 441 4 444 4 444 5 443 6 448 8 449 6 460 7 459 5 461 5 475 6 480 8 489 8 490 8 490 9 492 10 502 10 505 11 506 10 505 9 506 9 520 10ZM326 52 327 53 326 53 325 55 326 57 328 58 333 58 333 55 331 53 331 52 334 52 332 50 331 52 331 49 329 49 327 47 331 46 331 43 326 44 322 47 326 52ZM110 10 104 10 107 9 110 10ZM118 10 118 11 120 10 123 13 125 11 126 9 130 9 132 10 131 12 132 12 129 14 125 14 123 17 114 21 112 25 114 26 115 28 130 31 131 34 134 37 136 35 134 32 139 29 136 26 138 24 137 20 143 20 147 22 149 22 150 25 152 26 157 23 161 28 161 29 167 32 170 34 170 35 163 38 154 38 147 43 156 40 157 40 156 41 157 44 161 45 163 43 164 45 155 48 154 48 154 47 157 46 153 46 148 49 149 51 143 52 146 52 143 52 141 55 140 54 141 56 140 58 139 55 139 56 138 56 140 60 132 66 134 73 133 75 131 74 129 70 128 68 126 69 124 68 120 68 120 69 119 70 113 69 109 71 108 72 107 80 110 84 112 86 116 85 118 84 118 82 123 81 120 89 126 89 129 90 128 96 132 100 134 99 138 100 141 96 146 94 147 95 146 96 146 99 147 98 146 97 148 96 149 95 151 97 156 98 161 97 159 97 160 98 162 99 162 100 168 104 172 104 176 107 178 110 178 113 180 113 180 115 182 114 186 115 186 117 193 117 200 121 201 124 200 126 195 132 194 139 192 146 190 147 186 148 182 150 181 151 180 156 173 164 169 165 166 163 168 168 165 170 160 171 160 173 159 174 156 174 156 175 158 176 156 178 155 180 153 181 152 182 155 183 155 184 150 188 151 191 147 192 147 193 141 191 140 185 142 183 140 182 142 178 144 179 145 176 144 175 143 177 142 177 144 171 143 168 146 161 148 142 148 140 146 139 140 135 134 124 132 122 132 120 134 117 132 116 132 114 138 107 136 101 134 100 133 101 134 102 132 102 129 100 126 98 126 99 125 98 125 96 123 93 117 92 112 89 109 90 99 86 96 83 96 81 95 79 90 75 90 74 86 70 83 66 82 66 82 68 90 78 89 79 86 76 86 74 82 72 83 70 81 69 78 64 73 61 68 53 68 45 67 41 70 42 70 43 70 40 63 37 63 35 61 35 53 27 34 22 32 23 33 24 27 25 29 22 24 25 25 25 23 27 17 30 8 32 18 27 19 25 12 26 12 24 9 24 6 22 8 19 14 18 13 17 14 17 7 17 3 15 8 14 12 15 5 11 12 8 20 7 50 11 60 9 61 9 62 8 66 10 68 9 68 10 72 9 81 11 83 11 81 12 89 12 91 13 92 12 91 11 92 11 95 11 102 12 106 12 106 11 107 11 110 12 110 13 113 10 109 9 109 7 111 6 115 7 117 9 115 9 118 10ZM83 4 82 5 88 5 89 5 92 6 93 6 92 4 94 4 96 5 97 7 103 9 100 10 100 11 95 10 84 11 80 10 78 9 86 8 77 8 77 8 80 7 75 7 77 5 83 4ZM139 4 134 5 132 4 139 4ZM124 4 125 5 130 3 133 5 133 6 137 5 142 7 145 7 152 9 153 10 150 11 161 14 158 16 153 14 152 14 151 15 156 19 156 20 150 18 154 21 147 19 141 17 137 17 136 17 137 16 143 16 144 12 135 9 132 9 121 8 120 8 121 7 119 7 119 6 121 4 125 3 124 4ZM103 3 108 3 107 4 109 5 109 6 105 7 100 5 103 5 102 4 103 3ZM114 5 111 6 110 4 112 3 118 3 114 5ZM74 7 70 8 65 6 68 3 67 3 78 3 81 4 75 5 74 7ZM113 2 109 2 112 1 113 2ZM468 1 467 2 459 2 456 1 459 -0 468 1ZM106 -1 107 -0 107 1 100 1 100 -1 106 -1ZM92 -0 95 0 95 1 84 2 86 1 78 1 81 -1 91 1 88 -1 92 -0ZM338 8 329 7 330 5 333 4 332 3 336 2 335 1 351 -1 355 -1 339 3 335 5 335 7 338 8ZM112 -2 116 -1 120 1 132 0 134 2 122 2 115 2 113 -0 108 -1 112 -2ZM80 -2 79 -1 70 -0 76 -2 80 -2ZM289 -3 283 -2 284 -3 283 -3 287 -4 289 -3ZM110 -3 107 -3 106 -4 110 -3ZM104 -3 96 -4 98 -4 96 -5 104 -3ZM409 -3 400 -3 404 -5 409 -4 409 -3ZM280 -5 285 -4 281 -4 278 -1 276 -1 268 -5 280 -5ZM290 -7 293 -6 287 -5 278 -6 290 -7ZM329 -7 323 -6 319 -7 329 -7ZM401 -4 394 -5 388 -6 395 -8 401 -6 401 -4ZM123 -5 125 -5 118 -3 115 -3 113 -4 114 -5 109 -6 112 -8 115 -8 123 -5ZM151 -11 161 -9 152 -8 155 -8 147 -6 138 -5 140 -5 139 -4 141 -4 134 -2 137 -1 133 -0 120 -1 119 -1 122 -2 121 -3 126 -2 122 -4 126 -5 123 -6 131 -7 122 -7 116 -9 135 -11 151 -11ZM212 -11 222 -10 206 -9 219 -9 220 -9 218 -8 229 -9 234 -8 223 -6 226 -6 223 -4 223 -2 225 -1 220 -1 223 -0 223 1 222 1 224 3 220 3 222 3 222 4 218 4 219 6 216 5 220 7 220 8 218 8 215 7 215 8 213 9 219 9 211 11 205 12 202 14 193 16 191 19 189 20 190 21 188 24 181 22 176 18 172 13 174 11 176 11 177 9 171 9 172 8 176 8 170 6 171 5 166 1 151 -0 146 -1 153 -2 144 -3 155 -5 152 -6 160 -8 159 -9 178 -10 186 -8 183 -10 188 -11 212 -11Z" fill="#1B4A5C" stroke="#2A5C6C" stroke-width=".5" stroke-linejoin="round"/>
    <g stroke="#00D4B4" stroke-width="1" stroke-dasharray="2 4" fill="none" opacity=".6">
      <path d="M108.8 64.2 Q107 74 105.3 84"/>
      <path d="M142.6 52.4 Q250 -10 367.8 93.6"/>
      <path d="M367.8 93.6 Q400 70 432.3 91.2"/>
    </g>
    <g><circle cx="76.9" cy="62.3" r="9" fill="#00D4B4" opacity=".18"><animate attributeName="r" values="6;12;6" dur="3s" repeatCount="indefinite"/></circle><circle cx="76.9" cy="62.3" r="3.5" fill="#00D4B4" stroke="#0B232D" stroke-width="1.2"/><text x="70.9" y="56.3" text-anchor="end" font-size="10" fill="#C9DBDC">Los Angeles</text></g>
    <g><circle cx="96.6" cy="53.9" r="9" fill="#00D4B4" opacity=".18"><animate attributeName="r" values="6;12;6" dur="3s" repeatCount="indefinite"/></circle><circle cx="96.6" cy="53.9" r="3.5" fill="#00D4B4" stroke="#0B232D" stroke-width="1.2"/><text x="102.6" y="47.9" text-anchor="start" font-size="10" fill="#C9DBDC">Denver</text></g>
    <g><circle cx="108.8" cy="64.2" r="9" fill="#00D4B4" opacity=".18"><animate attributeName="r" values="6;12;6" dur="3s" repeatCount="indefinite"/></circle><circle cx="108.8" cy="64.2" r="3.5" fill="#00D4B4" stroke="#0B232D" stroke-width="1.2"/><text x="114.8" y="74.2" text-anchor="start" font-size="10" fill="#C9DBDC">Dallas</text></g>
    <g><circle cx="142.6" cy="52.4" r="9" fill="#00D4B4" opacity=".18"><animate attributeName="r" values="6;12;6" dur="3s" repeatCount="indefinite"/></circle><circle cx="142.6" cy="52.4" r="3.5" fill="#00D4B4" stroke="#0B232D" stroke-width="1.2"/><text x="148.6" y="48.4" text-anchor="start" font-size="10" fill="#C9DBDC">New York</text></g>
    <g><circle cx="105.3" cy="84.0" r="9" fill="#FFFFFF" opacity=".18"><animate attributeName="r" values="6;12;6" dur="3s" repeatCount="indefinite"/></circle><circle cx="105.3" cy="84.0" r="3.5" fill="#FFFFFF" stroke="#0B232D" stroke-width="1.2"/><text x="99.3" y="98.0" text-anchor="end" font-size="10" fill="#C9DBDC">Mexico City</text></g>
    <g><circle cx="367.8" cy="93.6" r="9" fill="#FFFFFF" opacity=".18"><animate attributeName="r" values="6;12;6" dur="3s" repeatCount="indefinite"/></circle><circle cx="367.8" cy="93.6" r="3.5" fill="#FFFFFF" stroke="#0B232D" stroke-width="1.2"/><text x="361.8" y="107.6" text-anchor="end" font-size="10" fill="#C9DBDC">Bengaluru</text></g>
    <g><circle cx="432.3" cy="91.2" r="9" fill="#FFFFFF" opacity=".18"><animate attributeName="r" values="6;12;6" dur="3s" repeatCount="indefinite"/></circle><circle cx="432.3" cy="91.2" r="3.5" fill="#FFFFFF" stroke="#0B232D" stroke-width="1.2"/><text x="438.3" y="85.2" text-anchor="start" font-size="10" fill="#C9DBDC">Manila</text></g>
    <text x="76" y="122" font-size="10" fill="#5F8A8C">Pacific · Mountain · Central · Eastern</text>
    <g font-size="12" fill="#C9DBDC"><text x="300" y="215"><tspan font-size="20" font-weight="600" fill="#00D4B4">6</tspan> time zones</text><text x="400" y="215"><tspan font-size="20" font-weight="600" fill="#00D4B4">55+</tspan> people at peak</text></g>
    <text x="40" y="250" font-size="11" fill="#5F8A8C">15,000+ clients supported around the clock</text>
  </svg>`,
  // 2 — AI in Zendesk
  `<svg viewBox="0 0 520 260" role="img" aria-label="SupportAgent AI results: 80% accuracy on day one, 45% backlog reduction, 36% faster response">
    <g font-family="IBM Plex Sans, sans-serif" font-size="13" fill="#C9DBDC">
      <text x="40" y="58">Accuracy out of the box</text>
      <text x="40" y="128">Ticket backlog</text>
      <text x="40" y="198">Response time</text>
    </g>
    <g fill="#1E4250"><rect x="40" y="68" width="440" height="18" rx="4"/><rect x="40" y="138" width="440" height="18" rx="4"/><rect x="40" y="208" width="440" height="18" rx="4"/></g>
    <g fill="#00D4B4"><rect x="40" y="68" width="352" height="18" rx="4"/><rect x="40" y="138" width="198" height="18" rx="4"/><rect x="40" y="208" width="158" height="18" rx="4"/></g>
    <g font-family="IBM Plex Sans, sans-serif" font-size="14" font-weight="600" fill="#00D4B4" text-anchor="end">
      <text x="480" y="58">80%</text><text x="480" y="128">−45%</text><text x="480" y="198">−36%</text>
    </g>
  </svg>`,
  // 3 — Revenue driver
  `<svg viewBox="0 0 520 260" role="img" aria-label="$2.87M ARR protected, $750K revenue loss prevented, 5% churn reduction, 7% annual profit increase">
    <g font-family="IBM Plex Sans, sans-serif" font-size="13" fill="#C9DBDC">
      <text x="40" y="52">ARR protected through retention and upsell</text>
      <text x="40" y="118">Revenue loss prevented via root-cause work</text>
    </g>
    <g fill="#1E4250"><rect x="40" y="62" width="440" height="18" rx="4"/><rect x="40" y="128" width="440" height="18" rx="4"/></g>
    <g fill="#00D4B4"><rect x="40" y="62" width="440" height="18" rx="4"/><rect x="40" y="128" width="115" height="18" rx="4"/></g>
    <g font-family="IBM Plex Serif, serif" font-size="16" font-weight="500" fill="#00D4B4" text-anchor="end"><text x="480" y="52">$2.87M</text><text x="480" y="118">$750K</text></g>
    <g stroke="#1E4250"><line x1="40" y1="168" x2="480" y2="168"/></g>
    <g font-family="IBM Plex Serif, serif" font-size="26" font-weight="500" fill="#fff"><text x="40" y="212">−5%</text><text x="280" y="212">+7%</text></g>
    <g font-family="IBM Plex Sans, sans-serif" font-size="12" fill="#C9DBDC"><text x="40" y="234">churn, top 10% of clients</text><text x="280" y="234">annual profit, two PE deals</text></g>
  </svg>`,
  // 4 — Speed and first touch
  `<svg viewBox="0 0 520 260" role="img" aria-label="Speed to answer about 15 seconds against a 30 second target, about 90 percent one-touch resolution, about 2 hour first reply, about 7 minute handle time against an 8 minute historical average" font-family="IBM Plex Sans, sans-serif">
    <g>
      <text x="40" y="48" font-size="28" font-weight="600" fill="#00D4B4">~15 sec</text>
      <text x="40" y="66" font-size="12" fill="#C9DBDC">speed to answer</text>
      <rect x="40" y="81" width="200" height="12" rx="3" fill="#1E4250"/>
      <rect x="40" y="81" width="107" height="12" rx="3" fill="#00D4B4"/><line x1="240" y1="78" x2="240" y2="96" stroke="#C9DBDC" stroke-width="1.5"/>
      <text x="40" y="112" font-size="10" fill="#5F8A8C">Tick marks the 30 sec target</text>
    </g>
    <g>
      <text x="290" y="48" font-size="28" font-weight="600" fill="#00D4B4">~90%</text>
      <text x="290" y="66" font-size="12" fill="#C9DBDC">one-touch resolution</text>
      <rect x="290" y="81" width="200" height="12" rx="3" fill="#1E4250"/>
      <rect x="290" y="81" width="184" height="12" rx="3" fill="#00D4B4"/>
      <text x="290" y="112" font-size="10" fill="#5F8A8C">Solved on first contact, top platforms</text>
    </g>
    <g>
      <text x="40" y="168" font-size="28" font-weight="600" fill="#00D4B4">~2 hrs</text>
      <text x="40" y="186" font-size="12" fill="#C9DBDC">first reply, business hours</text>
      <rect x="40" y="201" width="200" height="12" rx="3" fill="#1E4250"/>
      <rect x="40" y="201" width="70" height="12" rx="3" fill="#00D4B4"/>
      <text x="40" y="232" font-size="10" fill="#5F8A8C">Across 3,000+ tickets in 30 days</text>
    </g>
    <g>
      <text x="290" y="168" font-size="28" font-weight="600" fill="#00D4B4">~7 min</text>
      <text x="290" y="186" font-size="12" fill="#C9DBDC">average handle time</text>
      <rect x="290" y="201" width="200" height="12" rx="3" fill="#1E4250"/>
      <rect x="290" y="201" width="175" height="12" rx="3" fill="#00D4B4"/><line x1="490" y1="198" x2="490" y2="216" stroke="#C9DBDC" stroke-width="1.5"/>
      <text x="290" y="232" font-size="10" fill="#5F8A8C">Historical average about 8 min</text>
    </g>
  </svg>`,
];

const SLIDE_META = [
  { caption: 'CSAT turnaround, 12 months', sub: 'Rounded figures, company anonymized', legend: [['#00D4B4', 'CSAT score'], ['#1E4250', 'Tickets per month']], aria: 'CSAT turnaround' },
  { caption: "Teams I've led", sub: 'In-house and BPO, follow-the-sun', legend: [['#00D4B4', 'In-house teams, all US time zones'], ['#FFFFFF', 'BPO partners']], aria: "Teams I've led" },
  { caption: 'AI in Zendesk, first two weeks', sub: 'Real figures', legend: [['#00D4B4', 'SupportAgent AI, 15,000+ clients']], aria: 'AI results' },
  { caption: 'Support as a revenue driver', sub: 'Real figures', legend: [['#00D4B4', 'Measured across three companies']], aria: 'Revenue impact' },
  { caption: 'Speed and first touch', sub: 'Omnichannel KPIs, rounded', legend: [['#00D4B4', 'Result'], ['#C9DBDC', 'Target or prior baseline']], aria: 'Speed and first touch' },
];

const OPERATING_MODEL = [
  { n: 1, title: 'Listen at scale', body: <>Tiered ticket taxonomy built with Engineering and Product, so every contact becomes a data point about what's broken.</> },
  { n: 2, title: 'Fix it at the source', body: <>Feed the taxonomy into the roadmap. <b>Top categories down 40%.</b> Post-mortems cut repeat escalations 22% in six months.</> },
  { n: 3, title: "Automate what's left", body: <>SupportAgent AI and chatbots in Zendesk. <b>80% accuracy day one, 45% of backlog cleared,</b> 36% faster responses.</> },
  { n: 4, title: 'Scale the people', body: <>Follow-the-sun across six time zones, L1 to Senior Manager career paths, and right-sizing when the PE deal calls for it.</> },
  { n: 5, title: 'Report upward', body: <>Power BI and Zendesk Explore dashboards tying support health to churn risk. <b>$2.87M ARR protected</b> once leadership could see it.</> },
];

const EXPERIENCE = [
  {
    when: 'June 2025 – present',
    title: 'Head of Client Services',
    company: 'Malik Law Firm PLLC, Dallas',
    bullets: [
      'Independently designed and built a full digital transformation of the firm\'s client-facing operations.',
      'Leading digital transformation of client operations in a compliance-heavy legal environment.',
      'MyCase document automation cut administrative overhead 20% and shortened time-to-value for new clients.',
      '100% compliance across high volumes of sensitive client data.',
    ],
  },
  {
    when: 'Oct 2024 – June 2025',
    title: 'Head of Professional Services',
    company: 'Auction Technology Group',
    bullets: [
      'Redesigned enterprise onboarding across five products, speeding go-live and reducing early reliance on support.',
      'Training infrastructure drove 15% more self-service adoption and 96% CSAT.',
    ],
  },
  {
    when: 'Dec 2021 – Oct 2024',
    title: 'Head of Client Support, North America',
    company: 'Auction Technology Group',
    bullets: [
      'Protected $2.87M in ARR through retention programs and upsell openings found in support.',
      'Deployed SupportAgent AI in Zendesk: 45% backlog cut, 36% faster response, within two weeks.',
      'Secured C-suite funding for a 24/7 emergency line, then raised critical-issue resolution 20% for 15,000+ clients.',
      'Career-path frameworks from L1 to Senior Manager cut ramp time and improved retention.',
    ],
  },
  {
    when: 'Dec 2020 – Dec 2021',
    title: 'Head of Technical Support',
    company: 'Auction Mobility',
    bullets: [
      'SLA framework defined with the CTO: 36% faster resolution and 91% SLA compliance in the first quarter.',
      'Prevented $750K in revenue loss through root-cause analysis and structured escalations.',
      'Right-sized from 8 FTEs plus 15 BPO agents to a lean model during a PE transition, SLAs intact.',
    ],
  },
  {
    when: 'Aug 2013 – Dec 2020',
    title: 'Head of Client Services & Support',
    company: 'LiveAuctioneers, New York',
    bullets: [
      'Scaled support from 4 to 55+ FTEs across six time zones for 15,000+ clients at 94% CSAT.',
      'AI-powered support ecosystem cut ticket volume 25% and resolution time 36%.',
      'Strategic Enterprise tier for the top 10% of clients cut churn 5% across two PE transitions.',
      'Staffing optimization through two acquisitions drove a 7% annual profit increase at 98.9% CSAT.',
    ],
  },
];

const RECOGNITION = [
  ['5x Stevie Award winner', 'Customer Support Team of the Year, multiple categories'],
  ['Lean Six Sigma certified', 'Process improvement and waste reduction'],
  ['Customer experience and service management', 'CCXP · ITIL 4 Foundation'],
  ['AI and cloud', 'AWS Certified AI Practitioner · Google AI Certified'],
  ['IT support', 'CompTIA A+ · ITF+ · Google IT Support Professional Certificate'],
];

const CATEGORY_OPTIONS = [
  'Fine art', 'Antiques and collectibles', 'Estate', 'Jewelry and watches',
  'Vehicles', 'Equipment and industrial', 'Real estate', 'Livestock and agricultural',
  'Charity or benefit', 'Other',
];

const INITIAL_FORM = {
  name: '', email: '', company: '', phone: '', text_ok: false,
  location: '', start_date: '', format: 'Live', days: '', hours: '',
  category: 'Fine art', message: '',
};

const RESUME_URL = process.env.REACT_APP_RESUME_URL || '/Phillip_Labossiere_Resume.pdf';
const RESUME_LAST_UPDATED = process.env.REACT_APP_RESUME_LAST_UPDATED || 'September 2026';
const LINKEDIN_URL = process.env.REACT_APP_LINKEDIN_URL || 'https://www.linkedin.com/in/plabossiere/';
const HEADSHOT_URL = process.env.REACT_APP_HEADSHOT_URL || '/headshot.png';
const CURRENT_YEAR = new Date().getFullYear();

export default function Home() {
  const [current, setCurrent] = useState(0);
  const [ddOpen, setDdOpen] = useState(false);
  const [mobileNavOpen, setMobileNavOpen] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const [form, setForm] = useState(INITIAL_FORM);
  const [submitting, setSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState(null); // 'success' | 'error' | null
  const [submitError, setSubmitError] = useState('');

  const timerRef = useRef(null);
  const ddRef = useRef(null);
  const vizRef = useRef(null);
  const nameInputRef = useRef(null);

  const clearTimer = () => {
    if (timerRef.current) { clearInterval(timerRef.current); timerRef.current = null; }
  };
  const startTimer = useCallback(() => {
    clearTimer();
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    timerRef.current = setInterval(() => {
      setCurrent(c => (c + 1) % SLIDE_SVGS.length);
    }, 6000);
  }, []);

  // Carousel autoplay — kick off on mount; the timer self-resets via `go` and the hover handlers below.
  useEffect(() => {
    startTimer();
    return clearTimer;
  }, []);

  const go = (i) => { setCurrent(i); startTimer(); };

  // Pause on hover/focus for the carousel panel
  useEffect(() => {
    const el = vizRef.current;
    if (!el) return;
    const pause = () => clearTimer();
    const resume = () => startTimer();
    el.addEventListener('mouseenter', pause);
    el.addEventListener('mouseleave', resume);
    el.addEventListener('focusin', pause);
    el.addEventListener('focusout', resume);
    return () => {
      el.removeEventListener('mouseenter', pause);
      el.removeEventListener('mouseleave', resume);
      el.removeEventListener('focusin', pause);
      el.removeEventListener('focusout', resume);
    };
  }, [startTimer]);

  // Escape closes dropdown + modal
  useEffect(() => {
    const onKey = (e) => {
      if (e.key === 'Escape') {
        setDdOpen(false);
        setMobileNavOpen(false);
        setModalOpen(false);
      }
    };
    document.addEventListener('keydown', onKey);
    return () => document.removeEventListener('keydown', onKey);
  }, []);

  // Outside click closes dropdown
  useEffect(() => {
    const onClick = (e) => {
      if (ddRef.current && !ddRef.current.contains(e.target)) setDdOpen(false);
    };
    document.addEventListener('click', onClick);
    return () => document.removeEventListener('click', onClick);
  }, []);

  // Focus name field when modal opens; lock body scroll
  useEffect(() => {
    if (modalOpen) {
      document.body.style.overflow = 'hidden';
      setTimeout(() => nameInputRef.current?.focus(), 30);
    } else {
      document.body.style.overflow = '';
    }
    return () => { document.body.style.overflow = ''; };
  }, [modalOpen]);

  const openForm = () => {
    setDdOpen(false);
    setMobileNavOpen(false);
    setSubmitStatus(null);
    setSubmitError('');
    setModalOpen(true);
  };
  const closeForm = () => {
    setModalOpen(false);
    setSubmitStatus(null);
    setSubmitError('');
  };

  const handleField = (field) => (e) => {
    const v = e.target.type === 'checkbox' ? e.target.checked : e.target.value;
    setForm(f => ({ ...f, [field]: v }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    setSubmitStatus(null);
    setSubmitError('');
    try {
      const payload = {
        ...form,
        days: form.days === '' ? null : Number(form.days),
      };
      const res = await fetch(
        `${process.env.REACT_APP_BACKEND_URL}/api/services/clerking-request`,
        {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(payload),
        }
      );
      if (!res.ok) {
        const err = await res.json().catch(() => ({}));
        throw new Error(err?.detail || `Server error (${res.status})`);
      }
      setSubmitStatus('success');
      setForm(INITIAL_FORM);
    } catch (err) {
      setSubmitStatus('error');
      setSubmitError(err.message || 'Something went wrong.');
    } finally {
      setSubmitting(false);
    }
  };

  const downloadResume = () => {
    const a = document.createElement('a');
    a.href = RESUME_URL;
    a.download = 'Phillip_Labossiere_Resume.pdf';
    a.target = '_blank';
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  };

  return (
    <div className="pjl-site">
      {/* NAV */}
      <nav>
        <div className="wrap">
          <a className="name" href="#" data-testid="nav-name">Phillip Labossiere</a>
          <ul>
            <li><a href="#model">Operating model</a></li>
            <li><a href="#experience">Experience</a></li>
            <li className={`dd ${ddOpen ? 'open' : ''}`} ref={ddRef}>
              <button
                type="button"
                aria-haspopup="true"
                aria-expanded={ddOpen}
                onClick={(e) => { e.stopPropagation(); setDdOpen(v => !v); }}
                data-testid="nav-services-toggle"
              >
                Services
                <svg viewBox="0 0 10 10" fill="none" stroke="currentColor" strokeWidth="1.6" aria-hidden="true">
                  <path d="M1 3l4 4 4-4" />
                </svg>
              </button>
              <ul className="menu">
                <li>
                  <button type="button" onClick={openForm} data-testid="nav-clerking-open">
                    Auction Clerking
                    <small>Request a clerk for your sale</small>
                  </button>
                </li>
                <li>
                  <a href="https://cxsage.com" target="_blank" rel="noopener noreferrer">
                    CX &amp; Ops Consulting
                    <small>Through CX Sage</small>
                  </a>
                </li>
              </ul>
            </li>
            <li><a href="#contact">Contact</a></li>
          </ul>
          <button
            type="button"
            className="hamburger"
            aria-label={mobileNavOpen ? "Close menu" : "Open menu"}
            aria-expanded={mobileNavOpen}
            aria-controls="mnav-panel"
            onClick={(e) => { e.stopPropagation(); setMobileNavOpen(v => !v); }}
            data-testid="nav-hamburger"
          >
            {mobileNavOpen ? (
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" aria-hidden="true"><path d="M6 6l12 12M6 18L18 6"/></svg>
            ) : (
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" aria-hidden="true"><path d="M4 7h16M4 12h16M4 17h16"/></svg>
            )}
          </button>
        </div>
        <div id="mnav-panel" className={`mnav ${mobileNavOpen ? 'open' : ''}`}>
          <ul>
            <li><a href="#model" onClick={() => setMobileNavOpen(false)} data-testid="mnav-model">Operating model</a></li>
            <li><a href="#experience" onClick={() => setMobileNavOpen(false)} data-testid="mnav-experience">Experience</a></li>
            <li><div className="mgroup">Services</div></li>
            <li>
              <button type="button" onClick={openForm} data-testid="mnav-clerking">
                Auction Clerking
                <small>Request a clerk for your sale</small>
              </button>
            </li>
            <li>
              <a
                href="https://cxsage.com"
                target="_blank"
                rel="noopener noreferrer"
                onClick={() => setMobileNavOpen(false)}
                data-testid="mnav-cxsage"
              >
                CX &amp; Ops Consulting
                <small>Through CX Sage</small>
              </a>
            </li>
            <li><a href="#contact" onClick={() => setMobileNavOpen(false)} data-testid="mnav-contact">Contact</a></li>
          </ul>
        </div>
      </nav>

      {/* HERO */}
      <header className="hero">
        <div className="wrap">
          <div>
            <div className="who">
              <img src={HEADSHOT_URL} alt="Phillip Labossiere" />
              <div>
                <div className="nm">Phillip Labossiere</div>
                <div className="role-inline">Customer Support, CX &amp; Operations Leader</div>
              </div>
            </div>
            <h1 className="serif">Support that costs less every quarter and tells you what to build next.</h1>
            <p className="sub">
              15+ years running CX and operations at PE- and VC-backed SaaS companies. I build the team, cut the ticket volume at its source, put AI where it pays, and give the C-suite dashboards they actually open. Now doing the same inside a law practice.
            </p>
            <div className="cta">
              <a className="btn" href="#contact" data-testid="hero-contact-btn">Get in touch</a>
              <a
                className="btn line"
                href={LINKEDIN_URL}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="hero-linkedin-btn"
              >
                LinkedIn
              </a>
              <div className="stack">
                <button
                  type="button"
                  className="btn line"
                  onClick={downloadResume}
                  data-testid="hero-download-resume-btn"
                >
                  Download resume
                </button>
                <small data-testid="resume-last-updated">Last updated {RESUME_LAST_UPDATED}</small>
              </div>
            </div>
          </div>

          <div
            className="chart"
            id="viz"
            aria-label="Rotating charts of support metrics"
            ref={vizRef}
          >
            {SLIDE_SVGS.map((svg, i) => (
              <div key={`slide-${i}`} className={`slide ${i === current ? 'on' : ''}`} data-i={i}>
                <div className="cap">
                  <span>{SLIDE_META[i].caption}</span>
                  <span>{SLIDE_META[i].sub}</span>
                </div>
                {/* Safe: SVG strings are static constants defined above; no user input is rendered. */}
                <div dangerouslySetInnerHTML={{ __html: svg }} />
                <div className="legend">
                  {SLIDE_META[i].legend.map(([color, label]) => (
                    <span key={label}><i style={{ background: color }} />{label}</span>
                  ))}
                </div>
              </div>
            ))}
            <div className="dots" role="tablist" aria-label="Choose chart">
              {SLIDE_META.map((m, i) => (
                <button
                  key={`dot-${i}`}
                  role="tab"
                  aria-selected={i === current}
                  aria-label={m.aria}
                  onClick={() => go(i)}
                  data-testid={`carousel-dot-${i}`}
                />
              ))}
            </div>
          </div>
        </div>
      </header>

      {/* STATS BAND */}
      <div className="band">
        <div className="wrap">
          <div><b>94%</b><span>average CSAT</span></div>
          <div><b>36%</b><span>faster resolution</span></div>
          <div><b>$2.87M</b><span>revenue impact</span></div>
          <div><b>25%</b><span>ticket reduction</span></div>
          <div><b>55+</b><span>FTEs scaled</span></div>
        </div>
      </div>

      {/* OPERATING MODEL */}
      <section id="model">
        <div className="wrap">
          <h2 className="serif">The operating model I bring to every team</h2>
          <p className="lede">Same five steps, whether it's 15,000 auction clients or a law firm's caseload. The order matters.</p>
          <div className="model">
            {OPERATING_MODEL.map(step => (
              <div key={step.n}>
                <div className="n">{step.n}</div>
                <h4>{step.title}</h4>
                <p>{step.body}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* EXPERIENCE */}
      <section id="experience" className="exp">
        <div className="wrap">
          <h2 className="serif">Where it's worked</h2>
          <p className="lede">Four companies, three private equity transitions, one law firm.</p>
          {EXPERIENCE.map((job) => (
            <div className="job" key={`${job.company}|${job.when}`}>
              <div className="when">{job.when}</div>
              <div>
                <h4>{job.title}</h4>
                <div className="co">{job.company}</div>
                <ul>
                  {job.bullets.map((b) => <li key={b}>{b}</li>)}
                </ul>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* RECOGNITION */}
      <section>
        <div className="wrap">
          <ul className="recog">
            {RECOGNITION.map(([bold, muted]) => (
              <li key={bold}><b>{bold}</b><span>{muted}</span></li>
            ))}
          </ul>
        </div>
      </section>

      {/* SERVICES */}
      <section id="services">
        <div className="wrap">
          <h2 className="serif">Services</h2>
          <p className="lede">Two things I take on alongside a full-time role.</p>
          <div className="svcgrid">
            <div className="svc">
              <h4 className="serif">Auction clerking</h4>
              <p>Clerking for live, online, and hybrid sales. Seven years inside auction technology means I know the platforms, the pace, and what goes wrong on sale day.</p>
              <dl className="rates">
                <div><dt>Rate</dt><dd>$750 per auction day, up to 8 hours</dd></div>
                <div><dt>Overtime</dt><dd>$50 per additional hour, 12-hour maximum</dd></div>
                <div><dt>Travel</dt><dd>Expenses billed for assignments over 125 miles</dd></div>
              </dl>
              <button
                className="btn ink"
                type="button"
                onClick={openForm}
                data-testid="services-clerking-btn"
              >
                Request clerking
              </button>
            </div>
            <div className="svc">
              <h4 className="serif">CX and operations consulting</h4>
              <p>Support audits, team design, AI deployment, and executive reporting for SaaS, ecommerce, and auction technology companies. Delivered through CX Sage.</p>
              <a
                className="btn ink"
                href="https://cxsage.com"
                target="_blank"
                rel="noopener noreferrer"
                data-testid="services-cxsage-btn"
              >
                Visit CX Sage
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* CONTACT */}
      <section id="contact" className="contact">
        <div className="wrap">
          <h2 className="serif">Hiring a Support, CX &amp; Operations Leader?</h2>
          <p className="lede">Email is fastest. I reply within two business days.</p>
          <div className="links">
            <a href="mailto:plabossiere@gmail.com" data-testid="contact-email">plabossiere@gmail.com</a>
            <a
              href={LINKEDIN_URL}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="contact-linkedin"
            >
              LinkedIn
            </a>
            <span>Dallas, TX · remote friendly</span>
          </div>
        </div>
      </section>

      <div className="wrap">
        <footer>
          <span>© {CURRENT_YEAR} Phillip Labossiere</span>
          <span>
            Consulting through <a href="https://cxsage.com" target="_blank" rel="noopener noreferrer">CX Sage</a>
          </span>
        </footer>
      </div>

      {/* CLERKING MODAL */}
      <div
        className={`modal ${modalOpen ? 'open' : ''}`}
        role="dialog"
        aria-modal="true"
        aria-labelledby="mtitle"
        onClick={(e) => { if (e.target === e.currentTarget) closeForm(); }}
      >
        {modalOpen && (
          <form onSubmit={handleSubmit} data-testid="clerking-form">
            <h4 id="mtitle" className="serif">Request clerking</h4>
            <p className="lead">I reply within two business days.</p>

            {submitStatus === 'success' && (
              <div className="success" data-testid="clerking-success">
                Thanks — your request is in. I'll reply within two business days.
              </div>
            )}
            {submitStatus === 'error' && (
              <div className="error" data-testid="clerking-error">
                {submitError || "Couldn't send your request. Please try again or email plabossiere@gmail.com directly."}
              </div>
            )}

            <div className="row">
              <div>
                <label htmlFor="cf-name">Name</label>
                <input
                  id="cf-name"
                  ref={nameInputRef}
                  required
                  value={form.name}
                  onChange={handleField('name')}
                  data-testid="cf-name"
                />
              </div>
              <div>
                <label htmlFor="cf-email">Email</label>
                <input
                  id="cf-email"
                  type="email"
                  required
                  value={form.email}
                  onChange={handleField('email')}
                  data-testid="cf-email"
                />
              </div>
            </div>

            <div>
              <label htmlFor="cf-company">Company or auction house</label>
              <input id="cf-company" value={form.company} onChange={handleField('company')} data-testid="cf-company" />
            </div>

            <div>
              <label htmlFor="cf-phone">Phone</label>
              <input id="cf-phone" type="tel" value={form.phone} onChange={handleField('phone')} data-testid="cf-phone" />
              <label className="check">
                <input
                  type="checkbox"
                  checked={form.text_ok}
                  onChange={handleField('text_ok')}
                  data-testid="cf-text-ok"
                />
                It's okay to text me at this number
              </label>
            </div>

            <div>
              <label htmlFor="cf-location">Auction location or address</label>
              <input
                id="cf-location"
                placeholder="Venue, city, state, or 'online only'"
                value={form.location}
                onChange={handleField('location')}
                data-testid="cf-location"
              />
            </div>

            <div className="row">
              <div>
                <label htmlFor="cf-start">Start date</label>
                <input id="cf-start" type="date" value={form.start_date} onChange={handleField('start_date')} data-testid="cf-start" />
              </div>
              <div>
                <label htmlFor="cf-format">Format</label>
                <select id="cf-format" value={form.format} onChange={handleField('format')} data-testid="cf-format">
                  <option>Live</option>
                  <option>Online</option>
                  <option>Hybrid</option>
                </select>
              </div>
            </div>

            <div className="row">
              <div>
                <label htmlFor="cf-days">Number of auction days</label>
                <input
                  id="cf-days"
                  type="number"
                  min="1"
                  step="1"
                  value={form.days}
                  onChange={handleField('days')}
                  data-testid="cf-days"
                />
              </div>
              <div>
                <label htmlFor="cf-hours">Hours per day (or total)</label>
                <input
                  id="cf-hours"
                  placeholder="e.g. 6 per day or 14 total"
                  value={form.hours}
                  onChange={handleField('hours')}
                  data-testid="cf-hours"
                />
              </div>
            </div>

            <div>
              <label htmlFor="cf-cat">Auction category</label>
              <select id="cf-cat" value={form.category} onChange={handleField('category')} data-testid="cf-category">
                {CATEGORY_OPTIONS.map(o => <option key={o}>{o}</option>)}
              </select>
            </div>

            <div className="note">
              Clerking sessions include a 15-minute break every 3 hours. Please plan the sale schedule with that in mind.
            </div>

            <div>
              <label htmlFor="cf-message">Anything else I should know?</label>
              <textarea
                id="cf-message"
                required
                value={form.message}
                onChange={handleField('message')}
                data-testid="cf-message"
              />
            </div>

            <div className="actions">
              <button
                type="button"
                className="close"
                onClick={closeForm}
                data-testid="cf-cancel"
              >
                Cancel
              </button>
              <button
                className="btn ink"
                type="submit"
                disabled={submitting}
                data-testid="cf-submit"
              >
                {submitting ? 'Sending…' : 'Send request'}
              </button>
            </div>
          </form>
        )}
      </div>
    </div>
  );
}
